const ThemeColors = {
  primaryColor: "#ee556a",
  white: "#ffffff",
  darkGrey: "#48465b",
  success: "#79c447",
};

export default ThemeColors;
